import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { BadRequestError, StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export class DeleteRmaDraft extends RmaRequest<void, ExpectedErrors> {
  path = 'account/rma/draft/delete/'
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit = { method: 'DELETE' }
}

export { BadRequestError }
